//import { __ } from "@wordpress/i18n";
import MarketingMaterialGridPosts from "./MarketingMaterialGridPosts"


function MarketingMaterials() {
    
    return (
    <div>
        <MarketingMaterialGridPosts />
    </div>
    )
}

export default MarketingMaterials
